// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mQjX","content":"styles_content__24fMB"};